import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { TenantConfigService } from 'src/app/shared/services/tenant-config.service';
import { UserService } from '../common-services/user.services';

@Injectable({ providedIn: 'root' })
export class LandingGuard implements CanActivate {
  constructor(
    private router: Router,
    private tenantConfigService: TenantConfigService,
    private userService: UserService,
  ) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | UrlTree {
    const hasLandingPage = this.tenantConfigService.tenant.hasLandingPage === true;

    if (hasLandingPage && !this.userService.isLoggedIn()) {
      // Allow rendering HomeComponent anonymously
      return true;
    }

    if (this.userService.isLoggedIn()) {
      return this.router.parseUrl('/opportunities');
    }

    return this.router.parseUrl('/authentication/login');
  }
}


